export {Page, Page as default} from './page.component';
export {PageFooter} from './page-footer';
export {PageHeader} from './page-header';
export {PageMain} from './page-main';
export {PageNavbar} from './page-navbar';
export {PageSearch} from './page-search';
export {default as PageLogo} from './page-logo';
